import validate from "/home/runner/_work/injective-helix/injective-helix/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.5.0_@vue+compiler_53a779de65af0300001d8760d4eb5c27/node_modules/nuxt/dist/pages/runtime/validate.js";
import dev_45mode_45global from "/home/runner/_work/injective-helix/injective-helix/middleware/dev-mode.global.ts";
import maintenance_45global from "/home/runner/_work/injective-helix/injective-helix/middleware/maintenance.global.ts";
import route_45global from "/home/runner/_work/injective-helix/injective-helix/middleware/route.global.ts";
import manifest_45route_45rule from "/home/runner/_work/injective-helix/injective-helix/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.5.0_@vue+compiler_53a779de65af0300001d8760d4eb5c27/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  dev_45mode_45global,
  maintenance_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  connected: () => import("/home/runner/_work/injective-helix/injective-helix/middleware/connected.ts"),
  swap: () => import("/home/runner/_work/injective-helix/injective-helix/middleware/swap.ts")
}